import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BoxShadowEditorComponent } from './box-shadow-editor/box-shadow-editor.component';
import { BoxShadowSingleShadowComponent } from './box-shadow-single-shadow/box-shadow-single-shadow.component';
import { NumberPickerModule } from 'ZalamoLibrary/src/lib/ui/change-number/change-number.module';
import { ReactiveFormsModule } from '@angular/forms';
import { ColorPickerDirective } from 'ngx-color-picker';
import { ButtonModule } from 'ZalamoLibrary/src/lib/ui/button/button/button.module';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [BoxShadowEditorComponent, BoxShadowSingleShadowComponent],
  exports: [BoxShadowEditorComponent],
  imports: [
    CommonModule,
    NumberPickerModule,
    ReactiveFormsModule,
    ColorPickerDirective,
    ButtonModule,
    MatIconModule,
  ],
})
export class BoxShadowEditorModule {}
